module.exports = __webpack_public_path__ + "img/EN_flag.cec4d474.svg";